
// You can write more code here

/* START OF COMPILED CODE */

import UserComponent from "../core/UserComponent";
import Phaser from "phaser";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class DisableIfMobile extends UserComponent {

	constructor(gameObject: Phaser.GameObjects.Image | Phaser.GameObjects.Text) {
		super(gameObject);

		this.gameObject = gameObject;
		(gameObject as any)["__DisableIfMobile"] = this;

		/* START-USER-CTR-CODE */
		if (!this.scene.sys.game.device.os.desktop){
			this.gameObject.visible = false;
		}
		/* END-USER-CTR-CODE */
	}

	static getComponent(gameObject: Phaser.GameObjects.Image | Phaser.GameObjects.Text): DisableIfMobile {
		return (gameObject as any)["__DisableIfMobile"];
	}

	private gameObject: Phaser.GameObjects.Image | Phaser.GameObjects.Text;

	/* START-USER-CODE */

	// Write your code here.

	/* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
